<ng-container *ngIf="isDate; then dateInput; else numberInput"></ng-container>
<ng-template #numberInput>
  <div
    capraTooltip
    tooltipPlacement="bottom"
    [tooltipContent]="isBinned ? 'Range customization is not available for binned fields' : ''"
    [tooltipInteractive]="false"
    [tooltipDelay]="[500, 0]"
    [tooltipIsDisabled]="!isBinned"
  >
    <input
      class="form-control form-control-sm range-number-input"
      type="number"
      placeholder="Auto"
      attr.data-test="color-range-{{ label }}"
      [ngModel]="currentValue"
      [disabled]="isBinned"
      (ngModelChange)="onValueChange($event)"
      (keyup)="onKeyUp($event)"
      (blur)="onInputCommit()"
    />
  </div>
</ng-template>
<ng-template #dateInput>
  <mode-date-picker
    class="range-date-input"
    attr.data-test="color-range-date-{{ label }}"
    [date]="currentDate"
    [minDate]="startDate"
    placeholder="Auto"
    (dateChange)="onDateChange($event)"
  ></mode-date-picker>
</ng-template>
